import { render, staticRenderFns } from "./PromotionManagement.vue?vue&type=template&id=7151450c&"
import script from "./PromotionManagement.vue?vue&type=script&lang=ts&"
export * from "./PromotionManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports